<script lang="ts" setup>
import RadioButton from '#components/elements/radioButton/RadioButton.vue';
import { useLanguage } from '#composables/useLanguage';
import { isCumulativeOptionGuard } from '#domain/core/filter/components/periodSelector/periodSelector.model';
import type { DateSelectionOption } from '@carrefour-gcs/shared';
import { DATE_SELECTION_OPTIONS } from '@carrefour-gcs/shared';
import type { PropType } from 'vue';

export interface DateOptionsSelectorOptionType {
  value: string;
  label: string;
  subLabel?: string;
}

defineProps({
  selectedValue: { type: String as PropType<DateSelectionOption | null>, default: null },
  disabled: { type: Boolean, default: false },
  options: { type: Array<DateOptionsSelectorOptionType>, required: true },
  name: { type: String, required: true }
});

const emit = defineEmits<{
  check: [value: DateSelectionOption];
}>();

const { t } = useLanguage();

function onCheck(event: string) {
  if (!isCumulativeOptionGuard(event)) {
    throw new Error(`Invalid event value "${event}". Expected : ${JSON.stringify(DATE_SELECTION_OPTIONS)}`);
  }
  emit('check', event);
}
</script>

<template>
  <div>
    <div v-for="option in options" :key="option.value">
      <RadioButton
        :name="name"
        :disabled="disabled"
        :checked="selectedValue === option.value"
        :value="option.value"
        :label="t(option.label)"
        :sub-label="option.subLabel"
        :test-id="`${name}-${option.value}`"
        @check="onCheck($event)"
      />
    </div>
  </div>
</template>
